import envConfig from '@ey/voltron-config';

const config = {...envConfig.ad};
config.versionCheckUrl = envConfig.url.serviceUrl;
export default config;
